import { getMessageElement } from './page-resources';

export function showMessage(message: string, isError = false): void {
  const messageElement = getMessageElement();
  messageElement.classList.toggle('error', isError);
  messageElement.textContent = message;
}

export function clearMessage(): void {
  showMessage('');
}
